import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalizedRoutes } from './useLocalizedRoutes';

export const usePageTitle = () => {
  const { t } = useTranslation();
  const { currentRouteKey } = useLocalizedRoutes();
  const [title, setTitle] = useState('');
  const [prevPath, setPrevPath] = useState('');
  const [goBack, setGoBack] = useState(false);

  useEffect(() => {
    switch (currentRouteKey) {
      case 'home':
        setTitle(t('menu.item.mis-datos'));
        setPrevPath('');
        setGoBack(false);
        break;
      case 'newVehicle':
        setTitle(t('datos.vehiculos.nuevo.h1'));
        setPrevPath(t('menu.item.mis-datos'));
        setGoBack(true);
        break;
      case 'gasStations':
        setTitle(t('datos.gasolinera.card.h2'));
        setPrevPath(t('menu.item.mis-datos'));
        setGoBack(true);
        break;
      case 'invoices':
        setTitle(t('menu.item.facturas'));
        setPrevPath('');
        setGoBack(false);
        break;
      case 'billingData':
        setTitle(t('header.user-menu.datos-facturacion'));
        setPrevPath(t('menu.item.facturas'));
        setGoBack(true);
        break;
      case 'billingNew':
        setTitle(t('datos.facturacion.form.h1.new'));
        setPrevPath(t('menu.item.facturas'));
        setGoBack(true);
        break;
      case 'billingEdit':
        setTitle(t('datos.facturacion.form.h1.edit'));
        setPrevPath(t('menu.item.facturas'));
        setGoBack(true);
        break;
      case 'refuelings':
        setTitle(t('repostajes.h1'));
        setPrevPath('');
        setGoBack(false);
        break;
      case 'promotions':
        setTitle(t('menu.item.promociones'));
        setPrevPath('');
        setGoBack(false);
        break;
      case 'help':
        setTitle(t('menu.item.ayuda'));
        setPrevPath('');
        setGoBack(false);
        break;
      case 'fleetsMyFleets':
        setTitle(t('menu.item.flotas'));
        setPrevPath('');
        setGoBack(false);
        break;
      case 'fleetsAddBalance':
        setTitle(t('flotas.agregar-saldo.header.h1'));
        setPrevPath(t('menu.item.flotas'));
        setGoBack(true);
        break;
      case 'fleetsHistory':
        setTitle(t('header.user-menu.historial'));
        setPrevPath(t('menu.item.flotas'));
        setGoBack(true);
        break;
      case 'fleetsNewVehicle':
        setTitle(t('flotas.actions.add-vehiculo'));
        setPrevPath(t('menu.item.flotas'));
        setGoBack(true);
        break;
      default:
        setTitle('');
        setPrevPath('');
        setGoBack(false);
        break;
    }
  }, [currentRouteKey, t]);

  return { title, goBack, prevPath };
};
